/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Client contact details
 * @export
 * @interface GetContactDetails200Response
 */
export interface GetContactDetails200Response {
    /**
     * Primary admin email address — receives security notifications.
     */
    clientAdminEmail?: string;
    /**
     * Full name of the emergency contact person.
     */
    clientEmergencyContactName?: string;
    /**
     * Phone number of the emergency contact.
     */
    clientEmergencyContactPhone?: string;
}

/**
 * Check if a given object implements the GetContactDetails200Response interface.
 */
export function instanceOfGetContactDetails200Response(value: object): value is GetContactDetails200Response {
    return true;
}

export function GetContactDetails200ResponseFromJSON(json: any): GetContactDetails200Response {
    return GetContactDetails200ResponseFromJSONTyped(json, false);
}

export function GetContactDetails200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContactDetails200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'clientAdminEmail': json['client_admin_email'] == null ? undefined : json['client_admin_email'],
        'clientEmergencyContactName': json['client_emergency_contact_name'] == null ? undefined : json['client_emergency_contact_name'],
        'clientEmergencyContactPhone': json['client_emergency_contact_phone'] == null ? undefined : json['client_emergency_contact_phone'],
    };
}

export function GetContactDetails200ResponseToJSON(json: any): GetContactDetails200Response {
    return GetContactDetails200ResponseToJSONTyped(json, false);
}

export function GetContactDetails200ResponseToJSONTyped(value?: GetContactDetails200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'client_admin_email': value['clientAdminEmail'],
        'client_emergency_contact_name': value['clientEmergencyContactName'],
        'client_emergency_contact_phone': value['clientEmergencyContactPhone'],
    };
}

